// Mock data for EC SAFETRADE SOLUTIONS website

export const brand = {
  name: 'EC SAFETRADE SOLUTIONS',
  short: 'EC Safetrade',
  // Calling / display phone
  phone: '+91-7248851575',
  phoneRaw: '7248851575',
  // WhatsApp number (separate from calling number)
  whatsapp: '918920369913',
  whatsappDisplay: '+91-8920369913',
  whatsappMessage: "Hi EC Safetrade, I'm interested in your services. Please share more details.",
  // Public / notification email
  email: 'ecsafetradesolution@gmail.com',
  notifyEmail: 'ecsafetradesolution@gmail.com',
  domain: 'ecsafetradesolutions.in',
  address: 'J Block, New Delhi, India',
  branchOffice: 'Club Town Residency, MM Feeder Road, Kolkata - 700056',
  tagline: 'Empowering Digital Business Growth & Ecommerce Success',
};

export const stats = [
  { value: 30, suffix: 'k+', label: 'Merchant Base' },
  { value: 95, suffix: '%', label: 'YoY Growth' },
  { value: 92, suffix: '%', label: 'Renewal Rate' },
  { value: 98, suffix: '%', label: 'Happy Customers' },
];

export const solutions = [
  {
    title: 'Maximize Your Influence',
    desc: 'Boost visibility by 80% with local searches. Get listed on Google Maps to enhance your reach and improve rankings for increased traffic.',
    icon: 'TrendingUp',
  },
  {
    title: 'Strengthen Your Brand',
    desc: 'Boost accuracy by 85% with detailed creativity to enhance engagement by showcasing your business identity without makeovers.',
    icon: 'ShieldCheck',
  },
  {
    title: 'Expand Customer Reach',
    desc: 'Utilize strategies to enrich your listing with promotions and offers to drive 85% more interaction and build customer trust.',
    icon: 'Users',
  },
  {
    title: 'Enrich Customer Relations',
    desc: 'Improve user experience by 90% with mobile-friendly listings updates with easy navigation, calling controls, statistics.',
    icon: 'Heart',
  },
  {
    title: 'Drive Higher Conversions',
    desc: 'Boost effectiveness by 90% with analytics, a verified profile, optimized listing, local SEO, added activities, and growth reports.',
    icon: 'Target',
  },
  {
    title: 'Surpass Your Competitors',
    desc: 'Gain 90% competitive edge with an optimized listing with advanced SEO to boost visibility and attention.',
    icon: 'Trophy',
  },
];

// Mapping from item name → plan id (for Buy Now / Add to Cart)
export const itemPlanMap = {
  // E-commerce marketplaces (India — single platform ₹13k)
  'Amazon': 'single_qtr',
  'Flipkart': 'single_qtr',
  'Meesho': 'single_qtr',
  'Myntra': 'myntra_qtr',
  // Social media items
  'Instagram Growth': 'social_qtr',
  'Facebook Ads': 'social_qtr',
  'Content Creation': 'social_qtr',
  'Influencer Marketing': 'social_qtr',
  'Reels & Video': 'social_qtr',
  'Community Management': 'social_qtr',
  // Website items → custom quote (website plan)
  'Business Websites': 'website',
  'Shopify Stores': 'website',
  'WooCommerce': 'website',
  'Landing Pages': 'website',
  'SEO Optimization': 'website',
  'Maintenance': 'website',
};

export const marketplaces = [
  { name: 'Amazon', slug: 'amazon', color: '#FF9900', planId: 'single_qtr', desc: 'End-to-end Amazon Seller Central management, listing optimization, PPC ads, and A+ content.', logo: 'https://logo.clearbit.com/amazon.com' },
  { name: 'Flipkart', slug: 'flipkart', color: '#2874F0', planId: 'single_qtr', desc: 'Complete Flipkart account setup, catalog listing, promotions and performance management.', logo: 'https://logo.clearbit.com/flipkart.com' },
  { name: 'Meesho', slug: 'meesho', color: '#F43397', planId: 'single_qtr', desc: 'Meesho onboarding, cataloging, pricing strategy and order management services.', logo: 'https://logo.clearbit.com/meesho.com' },
  { name: 'Myntra', slug: 'myntra', color: '#FF3F6C', planId: 'myntra_qtr', desc: 'Fashion-forward listings, brand catalog, promotions and Myntra store growth strategy.', logo: 'https://logo.clearbit.com/myntra.com' },
  { name: 'eBay', slug: 'ebay', color: '#E53238', planId: 'ebay_etsy_qtr', desc: 'Global eBay seller account management, international listings and cross-border strategy.', logo: 'https://logo.clearbit.com/ebay.com' },
  { name: 'Etsy', slug: 'etsy', color: '#F16521', planId: 'ebay_etsy_qtr', desc: 'Etsy shop setup for handmade/craft brands, SEO, tags, and global order fulfillment.', logo: 'https://logo.clearbit.com/etsy.com' },
  { name: 'JioMart', slug: 'jiomart', color: '#008ECC', planId: 'jiomart_shopclues_qtr', desc: 'JioMart seller onboarding, catalog management and category-wise growth optimization.', logo: 'https://logo.clearbit.com/jiomart.com' },
  { name: 'ShopClues', slug: 'shopclues', color: '#8CC63F', planId: 'jiomart_shopclues_qtr', desc: 'ShopClues seller setup, listings, pricing management and promotion campaigns.', logo: 'https://logo.clearbit.com/shopclues.com' },
];

export const serviceSegments = [
  {
    id: 'ecommerce',
    title: 'E-Commerce Marketplace',
    subtitle: 'Sell on top online marketplaces',
    desc: 'Full-service seller account management across leading Indian and global marketplaces.',
    icon: 'ShoppingCart',
    items: ['Amazon', 'Flipkart', 'Meesho', 'Myntra', 'eBay', 'Etsy', 'JioMart', 'ShopClues'],
  },
  {
    id: 'social',
    title: 'Social Media Marketing',
    subtitle: 'Grow your brand socially',
    desc: 'Instagram & Facebook page management, ads, content strategy, influencer marketing and analytics.',
    icon: 'Share2',
    items: ['Instagram Growth', 'Facebook Ads', 'Content Creation', 'Influencer Marketing', 'Reels & Video', 'Community Management'],
  },
  {
    id: 'web',
    title: 'Website Development',
    subtitle: 'Custom websites & stores',
    desc: 'Design & development of modern responsive websites, ecommerce stores and landing pages.',
    icon: 'Code2',
    items: ['Business Websites', 'Shopify Stores', 'WooCommerce', 'Landing Pages', 'SEO Optimization', 'Maintenance'],
  },
];

// Detailed explanations shown when a service item / marketplace card is clicked
export const itemDetails = {
  // E-commerce marketplaces
  'Amazon': {
    title: 'Amazon Seller Services',
    tagline: 'India\u2019s #1 marketplace \u2014 unlock your growth here.',
    color: '#FF9900',
    summary: 'End-to-end management of your Amazon Seller Central account so you can focus on the product while we drive the sales.',
    features: [
      'Seller Central account setup & category approval',
      'Listing optimization with keywords, images and A+ content',
      'Sponsored Products, Brands & Display ad campaigns',
      'FBA / FBM logistics support and inventory planning',
      'Brand Registry, storefront design and A/B testing',
      'Returns, disputes and Account Health monitoring',
    ],
    outcomes: ['20\u201380% higher visibility', 'Better BSR ranking', 'Higher conversion rate'],
  },
  'Flipkart': {
    title: 'Flipkart Seller Services',
    tagline: 'Sell to 400M+ Flipkart shoppers across India.',
    color: '#2874F0',
    summary: 'Complete Flipkart account setup, catalog listing, ad campaigns and performance management.',
    features: [
      'Flipkart Seller Hub onboarding & GST setup',
      'Bulk cataloging with quality-check compliance',
      'PLA (Product Listing Ads) & PCA campaign optimisation',
      'Flipkart Plus & F-Assured enrollment',
      'Pricing, promotions and Big Billion Day readiness',
      'Order, returns and dispute resolution',
    ],
    outcomes: ['Faster listing approvals', 'Boosted sales in tier-2/3 cities', 'Improved seller rating'],
  },
  'Meesho': {
    title: 'Meesho Seller Services',
    tagline: 'Zero commission platform \u2014 huge growth potential.',
    color: '#F43397',
    summary: 'Meesho onboarding, cataloging, pricing strategy and order management for high-volume sellers.',
    features: [
      'Meesho supplier registration & bank verification',
      'Bulk catalog upload with 0% commission strategy',
      'Competitive pricing & win-buy-box optimisation',
      'Ads & Boosted Listings management',
      'RTO reduction and quality dispute handling',
      'Weekly performance reports',
    ],
    outcomes: ['High-volume order flow', 'Lower RTO', 'Repeat buyer growth'],
  },
  'Myntra': {
    title: 'Myntra Seller Services',
    tagline: 'India\u2019s biggest fashion marketplace.',
    color: '#FF3F6C',
    summary: 'Fashion-forward listings, brand catalog and growth strategy on Myntra.',
    features: [
      'Myntra Partner Portal onboarding',
      'Fashion cataloging with model & flat-lay photography guidance',
      'Style ID mapping and brand approval',
      'Myntra Fashion Ads (MFA) & M-Assured onboarding',
      'EORS / End Of Reason Sale planning',
      'Returns, sizing complaints and quality management',
    ],
    outcomes: ['Higher brand visibility', 'Better sell-through rate', 'Reduced size returns'],
  },
  'eBay': {
    title: 'eBay Seller Services',
    tagline: 'Sell globally \u2014 reach 130+ million buyers worldwide.',
    color: '#E53238',
    summary: 'Global eBay seller account management, international listings and cross-border strategy.',
    features: [
      'eBay Global Selling account setup',
      'International listings across US, UK, EU, AU',
      'Global shipping program & payments compliance',
      'Promoted Listings ads & discount campaigns',
      'Feedback and Top Rated Seller management',
      'Duty, customs and currency support',
    ],
    outcomes: ['Cross-border orders', 'Top Rated seller badge', 'Higher realisation per order'],
  },
  'Etsy': {
    title: 'Etsy Seller Services',
    tagline: 'The global home for handmade, vintage & craft.',
    color: '#F16521',
    summary: 'Etsy shop setup for handmade / craft brands with SEO, tags and global fulfillment.',
    features: [
      'Etsy shop creation & policy setup',
      'SEO-friendly titles, tags and descriptions',
      'Product photography guidance and mockups',
      'Etsy Ads & Offsite Ads optimisation',
      'International shipping profiles',
      'Reviews, favorites & customer engagement',
    ],
    outcomes: ['Search-page ranking', 'International orders', 'Loyal repeat buyers'],
  },
  'JioMart': {
    title: 'JioMart Seller Services',
    tagline: 'Reliance\u2019s omnichannel marketplace \u2014 tier-2/3 friendly.',
    color: '#008ECC',
    summary: 'JioMart seller onboarding, catalog management and category-wise growth optimisation.',
    features: [
      'JioMart Partner registration & GST/PAN verification',
      'Bulk catalog upload with category compliance',
      'Pricing & promotions for grocery + non-grocery',
      'JioMart ad slots & campaigns',
      'Order fulfillment and delivery coordination',
      'Grievance and returns handling',
    ],
    outcomes: ['Tier-2/3 India reach', 'Steady daily orders', 'Category leadership'],
  },
  'ShopClues': {
    title: 'ShopClues Seller Services',
    tagline: 'Value-priced marketplace with loyal Bharat shoppers.',
    color: '#8CC63F',
    summary: 'ShopClues seller setup, listings, pricing management and promotion campaigns.',
    features: [
      'Merchant Central onboarding',
      'Catalog & inventory management',
      'Pricing strategy for value shoppers',
      'Deals of the Day and Sunday Flea Market participation',
      'Shipping & COD support',
      'Weekly performance and payout tracking',
    ],
    outcomes: ['Volume orders', 'Value-shopper reach', 'Higher COD conversion'],
  },

  // Social Media items
  'Instagram Growth': {
    title: 'Instagram Growth',
    tagline: 'From 0 to loyal community \u2014 the right way.',
    color: '#DD2A7B',
    summary: 'Strategic Instagram management to build reach, engagement and paying customers.',
    features: [
      'Content strategy & monthly calendar',
      'Reels, carousels, stories and highlights',
      'Hashtag research and profile SEO',
      'Follower engagement & DMs',
      'Weekly analytics & growth reports',
    ],
    outcomes: ['3\u20135x follower growth', 'Higher DM enquiries', 'Direct sales from Instagram'],
  },
  'Facebook Ads': {
    title: 'Facebook & Meta Ads',
    tagline: 'Data-driven ads that actually convert.',
    color: '#1877F2',
    summary: 'End-to-end Meta Ads management \u2014 lead gen, catalog sales, retargeting and lookalikes.',
    features: [
      'Meta Business Suite & Ads Manager setup',
      'Audience research & lookalike modeling',
      'Creative ad copy & video ads',
      'Pixel installation and conversion tracking',
      'A/B testing and daily campaign optimisation',
    ],
    outcomes: ['Lower CPL / CPA', 'Higher ROAS', 'Predictable lead flow'],
  },
  'Content Creation': {
    title: 'Content Creation',
    tagline: 'Content that stops the scroll.',
    color: '#FF7A00',
    summary: 'Product photography, graphic design, copywriting and video creation for all your channels.',
    features: [
      'Product & lifestyle photography',
      'Reels, YouTube shorts & short-form videos',
      'Static creatives and carousels',
      'Copywriting & captions',
      'Brand identity & style guides',
    ],
    outcomes: ['Consistent brand voice', 'Higher engagement rate', 'Better ad creatives'],
  },
  'Influencer Marketing': {
    title: 'Influencer Marketing',
    tagline: 'Real people. Real reach. Real revenue.',
    color: '#8134AF',
    summary: 'Curated micro & macro-influencer collaborations to amplify your brand.',
    features: [
      'Influencer discovery in your niche',
      'Contract negotiation & campaign brief',
      'Content coordination and approvals',
      'Tracking with promo codes & UTMs',
      'ROI reports and re-usage rights',
    ],
    outcomes: ['Authentic UGC content', 'Wider audience reach', 'Boost in social proof'],
  },
  'Reels & Video': {
    title: 'Reels & Short Video',
    tagline: 'Where attention lives today.',
    color: '#F43397',
    summary: 'Reels-first content strategy for Instagram, YouTube Shorts and Facebook.',
    features: [
      'Script, hooks and trend research',
      'Shooting guidance or in-studio production',
      'Editing, subtitles and thumbnails',
      'Posting schedule & experimentation',
      'Analytics and iteration',
    ],
    outcomes: ['Viral reach potential', 'Higher watch time', 'Explosive follower growth'],
  },
  'Community Management': {
    title: 'Community Management',
    tagline: 'Turn followers into fans, fans into buyers.',
    color: '#26A45A',
    summary: 'Daily comment & DM responses, moderation and community-building programs.',
    features: [
      'Response within 30 minutes on business hours',
      'FAQ playbooks and brand voice',
      'Sentiment monitoring and crisis handling',
      'Customer stories & testimonials collection',
      'Loyalty and rewards programs',
    ],
    outcomes: ['Higher customer satisfaction', 'Better online reputation', 'Repeat purchases'],
  },

  // Website Development items
  'Business Websites': {
    title: 'Business Websites',
    tagline: 'A digital storefront that works 24/7.',
    color: '#1F8B4C',
    summary: 'Modern, mobile-first business websites tailored to your brand and goals.',
    features: [
      'Discovery, wireframing and design',
      'Custom design or premium templates',
      'CMS (WordPress) so you can update content easily',
      'On-page SEO and speed optimisation',
      'Domain, hosting and SSL setup',
    ],
    outcomes: ['Professional online presence', 'Enquiry & lead flow', 'Better Google ranking'],
  },
  'Shopify Stores': {
    title: 'Shopify Stores',
    tagline: 'Launch, sell and scale on Shopify.',
    color: '#96BF48',
    summary: 'Complete Shopify store development \u2014 from theme to conversion optimisation.',
    features: [
      'Store setup with premium theme customisation',
      'Product catalog, variants and inventory',
      'Payment gateway (Razorpay, Stripe, PayPal)',
      'Shipping profiles and integrations (Shiprocket, Delhivery)',
      'App stack & CRO recommendations',
    ],
    outcomes: ['Faster time-to-launch', 'Higher checkout conversion', 'Own your customer data'],
  },
  'WooCommerce': {
    title: 'WooCommerce Stores',
    tagline: 'Full control on WordPress + Woo.',
    color: '#7F54B3',
    summary: 'Custom WooCommerce e-commerce stores for merchants who want full ownership.',
    features: [
      'WordPress + WooCommerce setup',
      'Custom theme or premium template',
      'Payment, tax and shipping integrations',
      'Multi-currency and multi-language ready',
      'Speed, security and backup configuration',
    ],
    outcomes: ['No transaction fees', 'Full data ownership', 'Endless customisation'],
  },
  'Landing Pages': {
    title: 'Landing Pages',
    tagline: 'High-converting pages built for one goal.',
    color: '#FF7A00',
    summary: 'Focused landing pages for campaigns, launches and lead generation.',
    features: [
      'Conversion-focused copy and design',
      'A/B testing and heatmap analytics',
      'Fast-loading, mobile-first build',
      'Integrated forms, WhatsApp, Calendly',
      'Retargeting pixel installation',
    ],
    outcomes: ['Better ad ROAS', 'Higher form conversion', 'Faster campaign launches'],
  },
  'SEO Optimization': {
    title: 'SEO Optimization',
    tagline: 'Rank higher on Google \u2014 organically.',
    color: '#FFB629',
    summary: 'On-page and off-page SEO to bring free, high-intent traffic to your site.',
    features: [
      'Technical SEO audit & fixes',
      'Keyword research and content plan',
      'Meta tags, schema and internal linking',
      'Backlink outreach and citations',
      'Monthly ranking & traffic reports',
    ],
    outcomes: ['Higher Google ranking', 'Free organic traffic', 'Long-term compounding growth'],
  },
  'Maintenance': {
    title: 'Website Maintenance',
    tagline: 'Peace of mind after launch.',
    color: '#146638',
    summary: 'Ongoing updates, security patches, backups and content changes for your website.',
    features: [
      'Weekly backups and uptime monitoring',
      'Security patches and plugin updates',
      'Content and image updates on request',
      'Bug fixes and performance tuning',
      'Priority support via WhatsApp',
    ],
    outcomes: ['Zero downtime', 'Always-fresh content', 'Long-term security'],
  },
};

export const whyUs = [
  { title: 'Activate Seller Central', desc: 'Our experts have a 95% success rate in helping merchants carve their niche with store handling and setup.', icon: 'PlayCircle' },
  { title: 'Display Your Catalog', desc: 'With a 90% success rate, our specialists create engaging listings that attract buyers and boost sales.', icon: 'LayoutGrid' },
  { title: 'Brand Integrity Shield', desc: 'We manage your seller account with a 95% success rate — brand registry, optimization, ads, and orders.', icon: 'Shield' },
  { title: 'Ecommerce Ready Package', desc: 'Our experts achieve a 95% success rate in packaging, labeling, compliance and shipment.', icon: 'Package' },
  { title: 'Ecommerce Ad Solutions', desc: 'Advertising services improve efficiency by 90%, optimizing ads for better performance and sales.', icon: 'Megaphone' },
  { title: 'Ecommerce SEO', desc: 'Boost search visibility by up to 85% with our expert keyword research and listing optimization.', icon: 'Search' },
];

export const testimonials = [
  { name: 'Rohit Sharma', role: 'Founder, UrbanKart', text: 'EC Safetrade transformed our Amazon presence. Sales grew 3x in 6 months with their listing optimization.', rating: 5 },
  { name: 'Priya Verma', role: 'Owner, Fashion Studio', text: 'From Myntra to Meesho, they handled everything. Truly a one-stop ecommerce partner.', rating: 5 },
  { name: 'Anil Kumar', role: 'Director, HomeDecor Pvt Ltd', text: 'Their Instagram marketing brought us thousands of quality leads. Highly recommend!', rating: 5 },
  { name: 'Sneha Patel', role: 'Co-Founder, Crafts India', text: 'They set up our Etsy and eBay stores in weeks. International orders started flowing in.', rating: 5 },
  { name: 'Vikram Singh', role: 'CEO, TechGadgets', text: 'The website they built for us is stunning and fast. Conversion rate doubled.', rating: 5 },
  { name: 'Neha Gupta', role: 'MD, BeautyBloom', text: 'Professional team, transparent reporting and consistent results. Best in the industry.', rating: 5 },
];

export const faqs = [
  { q: 'Which marketplaces do you provide services for?', a: 'We cover Amazon, Flipkart, Meesho, Myntra, eBay, Etsy, JioMart, ShopClues and more — both Indian and global platforms.' },
  { q: 'Do you also handle social media marketing?', a: 'Yes. We manage Instagram and Facebook pages, run ads, create content, and drive engagement to grow your brand.' },
  { q: 'Can you build a custom website for my brand?', a: 'Absolutely. We build business websites, Shopify/WooCommerce stores, and high-converting landing pages.' },
  { q: 'How long does account setup take?', a: 'Typically 3–7 business days depending on the marketplace and documentation readiness.' },
  { q: 'Do you offer ad management?', a: 'Yes, we run PPC on Amazon/Flipkart, Meta Ads on Facebook & Instagram, and Google Ads.' },
];

export const heroImages = {
  main: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=900&q=80',
  side: 'https://images.unsplash.com/photo-1674027392887-751d6396b710?w=800&q=80',
  about: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=900&q=80',
  analytics: 'https://images.pexels.com/photos/7651801/pexels-photo-7651801.jpeg?w=900&q=80',
  service1: 'https://images.unsplash.com/photo-1586880244406-556ebe35f282?w=800&q=80',
  service2: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80',
  warehouse: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=900&q=80',
  social: 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=900&q=80',
  coding: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=900&q=80',
  team: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=1200&q=80',
  team2: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=900&q=80',
  product: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=900&q=80',
  packaging: 'https://images.pexels.com/photos/6169055/pexels-photo-6169055.jpeg?w=900&q=80',
  happyOwner: 'https://images.unsplash.com/photo-1647884866497-0bacd3f9e388?w=900&q=80',
};

export const brandLogos = [
  { name: 'Amazon', src: 'https://logo.clearbit.com/amazon.com' },
  { name: 'Flipkart', src: 'https://logo.clearbit.com/flipkart.com' },
  { name: 'Meesho', src: 'https://logo.clearbit.com/meesho.com' },
  { name: 'Myntra', src: 'https://logo.clearbit.com/myntra.com' },
  { name: 'eBay', src: 'https://logo.clearbit.com/ebay.com' },
  { name: 'Etsy', src: 'https://logo.clearbit.com/etsy.com' },
  { name: 'JioMart', src: 'https://logo.clearbit.com/jiomart.com' },
  { name: 'ShopClues', src: 'https://logo.clearbit.com/shopclues.com' },
  { name: 'Instagram', src: 'https://logo.clearbit.com/instagram.com' },
  { name: 'Facebook', src: 'https://logo.clearbit.com/facebook.com' },
];

// Hero carousel banners
export const heroBanners = [
  {
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1600&q=80',
    eyebrow: 'Data-driven growth',
    title: 'Scale Your Business Across 8+ Marketplaces',
    sub: 'End-to-end seller account management on Amazon, Flipkart, Meesho, Myntra, eBay, Etsy, JioMart & ShopClues.',
    accent: 'green',
  },
  {
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1600&q=80',
    eyebrow: 'Certified team',
    title: 'Your Dedicated Growth Partner',
    sub: '50+ certified marketplace, social media & web experts working exclusively on your brand.',
    accent: 'orange',
  },
  {
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1600&q=80',
    eyebrow: 'Social + Web',
    title: 'Reach Customers Everywhere',
    sub: 'Instagram & Facebook growth campaigns, plus custom Shopify / WooCommerce stores that convert.',
    accent: 'green',
  },
  {
    image: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=1600&q=80',
    eyebrow: 'Fulfilment ready',
    title: 'From Listing to Doorstep',
    sub: 'Cataloging, packaging, compliance and shipment support to keep your operations flowing.',
    accent: 'orange',
  },
];

// Homepage promo video (user-provided — H.264 baseline transcoded for max browser compatibility, with audio)
export const homeVideo = {
  src: '/videos/promo.mp4',
  poster: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=1600&q=80',
  title: 'How We Grow Your Sales',
  sub: 'See how our team works day-in and day-out to boost sales for Indian sellers across every major marketplace.',
};
